var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1347 1L55.0481 4.34821L58.8449 9.70536L62.865 19.3036L65.3217 31.1339H29.3641L31.5975 20.4196L36.0643 9.48214L41.2011 3.00893L44.7745 1H50.1347ZM1.22334 43.8571L2.78672 34.7054H25.1207L24.4506 51.2232L25.1207 59.9286H2.78672L1.22334 50.7768L1 50.1071V45.1964L1.22334 43.8571ZM93.0158 101L90.5591 99.8839L82.9656 92.2946L83.1889 90.2857L85.199 88.5L82.9656 85.8214L75.5954 88.9464H70.0119L64.6517 86.9375L59.9616 82.6964L57.5049 77.5625L57.0582 71.3125L59.0682 65.2857L62.6417 61.0446L66.2151 58.8125L71.3519 57.4732L76.9354 57.9196L82.7422 60.8214L86.3157 64.8393L88.549 70.8661L88.1024 77.7857L85.199 83.1429L87.6557 85.5982L90.3358 83.3661L92.1225 83.5893L99.2693 90.7321L100.609 93.8571V95.4196L100.386 95.8661L99.2693 98.7679L95.6959 100.777L95.4726 101H93.0158ZM68.0018 61.9375L65.3217 63.5L62.4183 66.625L61.3016 68.8571L60.6316 75.1071L63.0884 80.9107L65.9918 83.5893L69.5652 85.1518L73.5853 85.5982L76.2654 85.1518L80.2855 83.1429L82.5189 80.9107L84.9756 75.3304L84.7523 70.1964L81.6255 64.6161L77.6054 61.9375L71.5753 61.0446L68.0018 61.9375Z",
    fill: "#0088AF",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 43.8574V45.1967L1.22334 43.8574H1Z",
    fill: "#0088AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 50.1074V50.7771H1.22334L1 50.1074Z",
    fill: "#0088AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.609 95.4199L100.386 95.8663H100.609V95.4199Z",
    fill: "#0088AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 43.8574V45.1967L1.22334 43.8574H1Z",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 50.1074V50.7771H1.22334L1 50.1074Z",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.609 95.4199L100.386 95.8663H100.609V95.4199Z",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0341 4.34877L35.8409 2.33984L36.9576 2.56306L33.1608 7.47377L29.364 15.7327L26.684 24.6613L25.7906 31.1345H7.0301L7.47678 30.2416L6.80676 25.1077L9.48683 20.4202L15.0703 13.947L20.4305 9.4827L25.5673 6.58092L25.7906 7.25056H27.8007L28.2473 6.3577L30.0341 5.91127V4.34877ZM61.7483 7.9202L62.4183 7.25056H68.0018L68.8951 6.3577L75.8186 10.5988L82.0721 16.4023L87.4323 23.7684L90.7824 31.1345H69.1185L66.8851 19.9738L61.7483 7.9202ZM28.9174 34.7059H65.9917L66.6617 53.4559L66.215 55.2416L61.7483 57.2506L58.8448 59.9291H28.9174L28.024 51.2238L28.9174 34.7059ZM92.3457 58.3666L90.1124 64.6166L87.4323 60.3756L82.0721 56.1345L76.042 54.1256H70.0118L70.2351 40.9559L69.5651 34.7059H91.2291V57.4738L92.3457 58.3666ZM5.69006 67.2952L6.36008 66.8488V63.5006H25.7906L26.684 69.9738L29.364 78.9023L32.9375 86.7148L36.9576 92.2952L28.2473 89.6166L18.4204 83.5898L11.0502 76.2238L5.69006 67.2952ZM29.364 63.5006H55.9414L53.9314 68.6345L53.4847 75.3309L54.8247 80.6881L57.9515 86.2684L54.3781 90.9559L49.9113 93.6345H44.7745L40.9777 91.4023L37.1809 86.9381L33.6075 80.0184L31.1508 72.6523L29.364 63.5006ZM60.6316 88.5006L63.7583 90.7327L57.9515 92.2952L60.6316 88.5006Z",
    fill: "#0088AF",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.195 3.45508L60.1849 5.24079L61.7483 7.91936L62.4183 7.24972H68.0018L68.8951 6.35686L62.195 3.45508Z",
    fill: "#0088AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0341 4.34794L25.5673 6.58008L25.7906 7.24972H27.8007L28.2474 6.35686L30.0341 5.91044V4.34794Z",
    fill: "#0088AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12671 31.1336H7.03012L7.4768 30.2408L6.80678 25.1069L4.12671 31.1336Z",
    fill: "#0088AF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2291 57.4729L92.3458 58.3658L93.6858 51.4461V43.1872L92.3458 35.5979L91.2291 34.7051V57.4729Z",
    fill: "#0088AF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12671 63.4997L5.69008 67.2944L6.3601 66.8479V63.4997H4.12671Z",
    fill: "#0088AF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.195 3.45508L60.1849 5.24079L61.7483 7.91936L62.4183 7.24972H68.0018L68.8951 6.35686L62.195 3.45508Z",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0341 4.34794L25.5673 6.58008L25.7906 7.24972H27.8007L28.2474 6.35686L30.0341 5.91044V4.34794Z",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12671 31.1336H7.03012L7.4768 30.2408L6.80678 25.1069L4.12671 31.1336Z",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2291 57.4729L92.3458 58.3658L93.6858 51.4461V43.1872L92.3458 35.5979L91.2291 34.7051V57.4729Z",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12671 63.4997L5.69008 67.2944L6.3601 66.8479V63.4997H4.12671Z",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9515 2.33984L60.1849 5.24163L62.195 3.45592L57.9515 2.33984Z",
    fill: "#0088AF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6959 100.777H95.4726V101.001H95.6959V100.777Z",
    fill: "#0088AF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9515 2.33984L60.1849 5.24163L62.195 3.45592L57.9515 2.33984Z",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6959 100.777H95.4726V101.001H95.6959V100.777Z",
    stroke: "#0088AF",
    strokeWidth: 1.14286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.beb5febd60c44305fd175e5c69d6aaf1.svg";
export { ForwardRef as ReactComponent };